export default __webpack_public_path__ + "static/media/bottom-right-svg.1c41b9ed.svg";